
export default {
  name: 'Questions',
  async asyncData({ app, redirect }) {
    try {
      const { data } = await app.$api.getQuestionsPage()
      return {
        page: data.data.attributes,
        lessons: [],
        api: process.env.apiUrl,
      }
    } catch {
      redirect('/')
    }
  },
  head() {
    return this.$seo.generate(
      this.page?.serp,
      this.page?.social_sharing,
      this.page?.page_title_h1
    )
  },
  computed: {
    coverImg() {
      if (!this.page?.cover_image?.data) {
        return ''
      }
      return this.page.cover_image.data.attributes.url
    },
  },
}
